(function () {
  'use strict';

  if (customElements.get('view-products-component')) return;

  customElements.define(
    'view-products-component',
    class extends HTMLElement {
      connectedCallback() {
        this.groupTabs = this.querySelectorAll('[data-view-products-group-tab]');
        this.groupPanels = this.querySelectorAll('[data-group-panel]');
        this.interactionWrap = this.querySelector('[data-view-products-interaction-wrap]');
        this.detailBody = this.querySelector('[data-view-products-detail-body]');
        this.detailBest = this.querySelector('[data-view-products-detail-best]');
        this.pointerFine =
          typeof window.matchMedia !== 'undefined' &&
          window.matchMedia('(pointer: fine)').matches;

        if (!this.pointerFine) {
          this.classList.add('view-products-component--use-click-selection');
        }

        this.initTabs();
        this.initCards();
        this.listenDesignMode();
      }

      getVisiblePanel() {
        return Array.from(this.groupPanels).find((p) => !p.hidden);
      }

      updateDetailFromCard(card) {
        const descId = card.getAttribute('data-description-id');
        if (descId && this.detailBody) {
          const source = document.getElementById(descId);
          if (source) this.detailBody.innerHTML = source.innerHTML;
        }

        const bestId = card.getAttribute('data-best-for-id');
        if (this.detailBest) {
          if (bestId) {
            const bestSource = document.getElementById(bestId);
            if (bestSource && bestSource.innerHTML.trim() !== '') {
              this.detailBest.innerHTML = bestSource.innerHTML;
              this.detailBest.hidden = false;
            } else {
              this.detailBest.innerHTML = '';
              this.detailBest.hidden = true;
            }
          } else {
            this.detailBest.innerHTML = '';
            this.detailBest.hidden = true;
          }
        }
      }

      clearDesktopHoverState() {
        this.querySelectorAll('.view-products__cards-grid--hovering').forEach((grid) => {
          grid.classList.remove('view-products__cards-grid--hovering');
        });
        this.querySelectorAll('[data-view-products-card]').forEach((c) => {
          c.classList.remove('view-products__card--selected');
          c.setAttribute('aria-pressed', 'false');
        });
        const first = this.getVisiblePanel()?.querySelector('[data-view-products-card]');
        if (first) this.updateDetailFromCard(first);
      }

      listenDesignMode() {
        if (typeof Shopify === 'undefined' || !Shopify.designMode) return;

        document.addEventListener('shopify:block:select', (event) => {
          const target = event.target;
          if (!this.contains(target)) return;
          const card = target.closest('[data-view-products-card]');
          if (!card) return;

          const panel = card.closest('[data-group-panel]');
          const idx = panel?.getAttribute('data-group-index');
          if (idx != null && this.groupTabs.length) {
            this.groupTabs.forEach((tab) => {
              const match = tab.getAttribute('data-group-index') === idx;
              tab.setAttribute('aria-selected', match ? 'true' : 'false');
              tab.classList.toggle('view-products__tab--active', match);
            });
            this.groupPanels.forEach((p) => {
              p.hidden = p.getAttribute('data-group-index') !== idx;
            });
          }

          this.activateCard(card, false);
        });
      }

      initTabs() {
        this.groupTabs.forEach((tab) => {
          tab.addEventListener('click', () => {
            const idx = tab.getAttribute('data-group-index');
            if (idx == null) return;

            this.groupTabs.forEach((t) => {
              t.setAttribute('aria-selected', 'false');
              t.classList.remove('view-products__tab--active');
            });
            tab.setAttribute('aria-selected', 'true');
            tab.classList.add('view-products__tab--active');

            this.groupPanels.forEach((panel) => {
              panel.hidden = panel.getAttribute('data-group-index') !== idx;
            });

            const activePanel = Array.from(this.groupPanels).find(
              (p) => p.getAttribute('data-group-index') === idx && !p.hidden
            );
            const firstCard = activePanel?.querySelector('[data-view-products-card]');
            if (firstCard) {
              if (this.pointerFine) {
                this.clearDesktopHoverState();
                this.updateDetailFromCard(firstCard);
              } else {
                this.activateCard(firstCard, false);
              }
            }

            document.dispatchEvent(new CustomEvent('theme:resize'));
          });
        });
      }

      initCards() {
        this.querySelectorAll('[data-view-products-card]').forEach((card) => {
          if (this.pointerFine) {
            card.addEventListener('mouseenter', () => {
              this.activateCard(card, false);
            });
          } else {
            card.addEventListener('click', (event) => {
              if (card.tagName === 'A') {
                const href = card.getAttribute('href');
                if (href && href !== '#' && href !== '') {
                  return;
                }
              }
              event.preventDefault();
              this.activateCard(card, true);
            });
          }

          card.addEventListener('focusin', () => {
            requestAnimationFrame(() => {
              if (this.pointerFine && !card.matches(':focus-visible')) {
                return;
              }
              this.activateCard(card, false);
            });
          });
        });

        if (this.interactionWrap && this.pointerFine) {
          this.interactionWrap.addEventListener('mouseleave', () => {
            this.clearDesktopHoverState();
          });
        }
      }

      activateCard(card, dispatchResize) {
        const panel = card.closest('[data-group-panel]');
        if (!panel) return;

        panel.querySelectorAll('[data-view-products-card]').forEach((c) => {
          c.classList.remove('view-products__card--selected');
          c.setAttribute('aria-pressed', 'false');
        });

        card.classList.add('view-products__card--selected');
        card.setAttribute('aria-pressed', 'true');

        const grid = card.closest('.view-products__cards-grid');
        if (grid && this.pointerFine) {
          panel.querySelectorAll('.view-products__cards-grid').forEach((g) => {
            g.classList.remove('view-products__cards-grid--hovering');
          });
          grid.classList.add('view-products__cards-grid--hovering');
        }

        this.updateDetailFromCard(card);

        if (dispatchResize) document.dispatchEvent(new CustomEvent('theme:resize'));
      }
    }
  );
})();
